import React, { useEffect, useState } from "react";
import request from "../../../../Helpers/API";

export const ResponsableSelect2 = ({ name, value, onChange }) => {
  const [state, setState] = useState([]);
  // const [responsablesCobranza, setResponsablesCobranza] = useState([]);

  // useEffect(() => {
  //   request
  //     .get("GenerarConvenioModal/DropDownListResponsables")
  //     .then((result) => {
  //       setResponsablesCobranza(result);
  //       const responsablesOptions = result.map((responsable) => ({
  //         linea: responsable.responsable_cobranza, 
  //         value: responsable.idusuario, 
  //       }));
  //       setState(responsablesOptions);
  //     })
  //     .catch((error) => {
  //       JSON.stringify("PERMISOS", "ERROR....", "error");
  //     });
  // }, []);

  return (
    <select
      className="select-responsable"
      name={name}
      value={value}
      onChange={onChange}
    >
      <option value="CC">Consolidado</option>
      <option value="EC">Ejecutivo</option>
      <option value="CS">Cobranza Sinaloa</option>
      <option value="CN">Cobranza Nayarit</option>
      <option value="GC">Gerencia</option>
      {state.map((item) => (
        <option key={`linea-${item.value}`} value={item.value}>
          {item.linea}
        </option>
      ))}
    </select>
  );
};